module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_champagne-fcc143bfb58b58d8e6fa61d1ade5edb4.png";